import styled from 'styled-components';
import LazyLoadImage from '~/components/utilities/lazyload-image';
import { useBannerContext } from '../context/banner-context';
import { IMG_SIZES } from '../config';
import BackgroundImage from './background-image';
import breakpoint from '~/utils/style-utils';

const BLUR_RADIUS_DESKTOP = 50;
const BLUR_OFFSET_DESKTOP = BLUR_RADIUS_DESKTOP * 2;

const BLUR_RADIUS_MOBILE = 20;
const BLUR_OFFSET_MOBILE = BLUR_RADIUS_MOBILE * 3;

const Container = styled.div<{ hideOnDesktop: boolean; hideOnMobile: boolean }>`
	z-index: 1;
	position: relative;
	grid-area: terms;
	overflow: hidden;

	${({ hideOnMobile }) =>
		`
			display: ${hideOnMobile ? 'none' : 'block'};
	`}

	${({ hideOnDesktop }) =>
		breakpoint.lg`
			display: ${hideOnDesktop ? 'none' : 'block'};
	`}
`;

const BackgroundContainer = styled.div`
	position: absolute;
	top: ${`-${BLUR_OFFSET_MOBILE}px`};
	left: ${`-${BLUR_OFFSET_MOBILE}px`};
	right: ${`-${BLUR_OFFSET_MOBILE}px`};
	bottom: ${`-${BLUR_OFFSET_MOBILE}px`};

	img {
		object-position: bottom;
		filter: ${`blur(${BLUR_RADIUS_MOBILE}px)`};
	}

	${breakpoint.lg`
		top: -${BLUR_OFFSET_DESKTOP}px;
		left: -${BLUR_OFFSET_DESKTOP}px;
		right: -${BLUR_OFFSET_DESKTOP}px;
		bottom: -${BLUR_OFFSET_DESKTOP}px;

		img {
			filter: blur(${BLUR_RADIUS_DESKTOP}px);
		}
	`}
`;

const Content = styled.div`
	z-index: 1;
	position: relative;
	display: flex;
	align-items: center;
	font: var(--bannerTermsConditionsFont);
	background: rgba(255, 255, 255, 0.2);
	padding: 12px;

	${breakpoint.lg`
		padding: 12px 24px;
	`}
`;

const IconContainer = styled.div`
	margin-right: 6px;

	img {
		pointer-events: none;

		max-width: 108px;
		height: 36px;
	}

	${breakpoint.lg`
		margin-right: 12px;
		img {
			max-width: 144px;
			height: 48px;
		}
	`}
`;

const Text = styled.div`
	flex: 1;
	color: rgba(var(--font-light), 1);
	word-break: break-word;
`;

const Terms: React.FC = () => {
	const {
		data: { tcText, tcImage, mobileLayoutType, url },
		helpers: { shouldLazyLoad }
	} = useBannerContext();

	return (
		<Container hideOnDesktop={!tcText} hideOnMobile={mobileLayoutType === 'SHORT'}>
			<BackgroundContainer>
				<BackgroundImage />
			</BackgroundContainer>

			<Content>
				{tcImage && (
					<IconContainer>
						<LazyLoadImage
							src={tcImage.src}
							srcSet={tcImage.srcSet}
							sizes={IMG_SIZES.foreground}
							alt={url || ''}
							lazyload={shouldLazyLoad}
							roundCorners={undefined}
							loading={undefined}
							smartImage={undefined}
							onLoad={undefined}
						/>
					</IconContainer>
				)}
				<Text>{tcText}</Text>
			</Content>
		</Container>
	);
};

export default Terms;
